import { ApiRequest, GetBaseServiceFunctions } from '../baseService'

const BaseRoute = 'app/talking-point'
const baseFunctions = GetBaseServiceFunctions(BaseRoute)
const API = { ...baseFunctions }
export default API
